getPathType